import { Component } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from '@platform/base';
import NCTabPane from '../NCTabPane';
import CompMeta from '../../meta/LowCodeComponents/Tabs';
const positionEnum = ['left', 'right', 'top', 'bottom'];
/**
 * @class NCTabs
 * @column 1
 * @compType 1
 * @canAppend true
 * @path LowCodeComponents.NCTabs
 * @label 页签
 *
 */
class NCTabs extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title activeKey
         * @description 激活的tabPanel的key
         */
        activeKey: PropTypes.string,
        /**
         * @title tabBarPosition
         * @description tab头的定位
         */
        tabBarPosition: PropTypes.oneOf(positionEnum),
    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <Tabs {...this.props} className="lc-drop-area">
                {this.props.children}
            </Tabs>
        )
    }
}


NCTabs.TabPane = NCTabPane;
export default NCTabs;
